import { merge } from 'lodash';

const initialState = {
  titulo: '',
  movimentacaoBlindada: {
    id: null,
    nome: '',
    data_base: null,
    atualizar_ate: null
  },
  simulacaoLaudoIncremental: {
    id: null,
    nome: '',
    data_base: null,
    data_simulacao_laudo: null
  },
  predicaoBaixas: {
    id: null,
    data_base: null,
    nome: ''
  },
  arquivoCapex: {
    id: "",
    fileObj: undefined,
    delimitador: `;`,
    involucro: `"`,
    escape: `"`,
    uploading: false,
    fakeFile: false,
    headerValido: false
  }
};
  
const state = initialState;
  
const getters = {};
  
const actions = {
  setProjecaoBrr({ commit }, value) {
    commit('SET_PROJECAO_BRR', value)
  },
  clearProjecaoBrr({ commit }, value) {
    commit('CLEAR_PROJECAO_BRR', initialState)
  }
};
  
const mutations = {
  SET_PROJECAO_BRR: (state, value) => (state = merge(state, value)),
  CLEAR_PROJECAO_BRR: (state, value) => {
    state = merge(state, value);
    state.arquivoCapex.fileObj = undefined;
  }
};
  
export default {
  state,
  getters,
  actions,
  mutations
};